import { useTranslation } from 'react-i18next';
import SearchableSelect from '../SearchableSelect';
import { useClientSelection } from '../../contexts/ClientSelectionContext';

/**
 * Global acting-client dropdown shown in the header (admins, and later
 * multi-store users). Renders nothing for single-client users.
 */
export default function ClientSelector({ className }: { className?: string }) {
  const { t } = useTranslation();
  const { showSelector, effectiveClientId, setSelectedClientId, clients } = useClientSelection();

  if (!showSelector) return null;

  return (
    <SearchableSelect
      options={clients.map((c) => ({ value: c.id, label: c.name }))}
      // effectiveClientId, not raw selection: multi-store users default to
      // their primary store and the dropdown must show it, not a placeholder
      value={effectiveClientId ?? ''}
      onChange={setSelectedClientId}
      placeholder={t('nav.selectClientPlaceholder')}
      className={className}
    />
  );
}
